import {
    GET_TREND_ANGGOTA,
    GET_TREND_ANGGOTA_SUCCESS,
    GET_TREND_ANGGOTA_FAIL,

    GET_ANGGOTA_OVERVIEW,
    GET_ANGGOTA_OVERVIEW_SUCCESS,
    GET_ANGGOTA_OVERVIEW_FAIL,

    GET_ANGGOTA_PROVINSI,
    GET_ANGGOTA_PROVINSI_SUCCESS,
    GET_ANGGOTA_PROVINSI_FAIL,
    GET_ANGGOTA_KABKOT,
    GET_ANGGOTA_KABKOT_SUCCESS,
    GET_ANGGOTA_KABKOT_FAIL,
    GET_ANGGOTA_KECAMATAN,
    GET_ANGGOTA_KECAMATAN_SUCCESS,
    GET_ANGGOTA_KECAMATAN_FAIL,
  } from "./actionTypes";
  import { API } from "../../API/api";
  
  // get exco table
  export const getTrendAnggota = (tingkat_exco,id_daerah,tanggal,satuan) => (dispatch) => {
    dispatch({
      type: GET_TREND_ANGGOTA,
    });
  
    const request = API.getTrendAnggota(tingkat_exco,id_daerah,tanggal,satuan);
    return request.then(
      (response) => dispatch(getTrendAnggotaSuccess(response.data)),
      (err) => dispatch(getTrendAnggotaFail(err))
    );
  };
  
  export const getTrendAnggotaSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_TREND_ANGGOTA_SUCCESS,
      payload: data,
    });
  };
  
  export const getTrendAnggotaFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_TREND_ANGGOTA_FAIL,
      payload: data,
    });
  };

  export const getAnggotaOverview = (tingkat_exco,id_daerah) => (dispatch) => {
    dispatch({
      type: GET_ANGGOTA_OVERVIEW,
    });
  
    const request = API.getAnggotaOverview(tingkat_exco,id_daerah);
    return request.then(
      (response) => dispatch(getAnggotaOverviewSuccess(response.data)),
      (err) => dispatch(getAnggotaOverviewFail(err))
    );
  };
  
  export const getAnggotaOverviewSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_OVERVIEW_SUCCESS,
      payload: data,
    });
  };
  
  export const getAnggotaOverviewFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_OVERVIEW_FAIL,
      payload: data,
    });
  };

  export const getAnggotaProvinsi = (order_type,order_by,search,pemenuhan_target) => (dispatch) => {
    dispatch({
      type: GET_ANGGOTA_PROVINSI,
    });
  
    const request = API.getAnggotaProvinsi(order_type,order_by,search,pemenuhan_target);
    return request.then(
      (response) => dispatch(getAnggotaProvinsiSuccess(response.data)),
      (err) => dispatch(getAnggotaProvinsiFail(err))
    );
  };
  
  export const getAnggotaProvinsiSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_PROVINSI_SUCCESS,
      payload: data,
    });
  };
  
  export const getAnggotaProvinsiFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_PROVINSI_FAIL,
      payload: data,
    });
  };

  export const getAnggotaKabkot = (order_type,order_by,search,id_provinsi,pemenuhan_target) => (dispatch) => {
    dispatch({
      type: GET_ANGGOTA_KABKOT,
    });
  
    const request = API.getAnggotaKabkot(order_type,order_by,search,id_provinsi,pemenuhan_target);
    return request.then(
      (response) => dispatch(getAnggotaKabkotSuccess(response.data)),
      (err) => dispatch(getAnggotaKabkotFail(err))
    );
  };
  
  export const getAnggotaKabkotSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_KABKOT_SUCCESS,
      payload: data,
    });
  };
  
  export const getAnggotaKabkotFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_KABKOT_FAIL,
      payload: data,
    });
  };

  export const getAnggotaKecamatan = (order_type,order_by,search,id_kabkot,pemenuhan_target) => (dispatch) => {
    dispatch({
      type: GET_ANGGOTA_KECAMATAN,
    });
  
    const request = API.getAnggotaKecamatan(order_type,order_by,search,id_kabkot,pemenuhan_target);
    return request.then(
      (response) => dispatch(getAnggotaKecamatanSuccess(response.data)),
      (err) => dispatch(getAnggotaKecamatanFail(err))
    );
  };
  
  export const getAnggotaKecamatanSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_KECAMATAN_SUCCESS,
      payload: data,
    });
  };
  
  export const getAnggotaKecamatanFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_ANGGOTA_KECAMATAN_FAIL,
      payload: data,
    });
  };

  